import { authDelete } from "@api";

import { PolicyWithRules } from "@pages/policy/types";

export const deletePolicy = (
  deploymentId: string,
  policy: PolicyWithRules
): Promise<PolicyWithRules> => {
  const path = `/api/agent/deployments/${deploymentId}/policies/${policy.slug}`;
  return authDelete<PolicyWithRules>(path);
};
